var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root",attrs:{"id":"app"}},[_c('main',{staticClass:"app-main"},[_c('router-view')],1),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }